// src/components/ClaimDetail/RecoverableDepreciationCard.jsx
//
// Pestaña "Datos" de la ficha: la depreciación recuperable (RD) del reclamo
// a la mano — monto del estimado, estado y cuándo se pidió — para no tener
// que abrir el estimado cada vez que se pide (pedido del cliente,
// 2026-10-21). El monto se carga en "Decisión de cobertura recibida" o en
// "Editar reclamo"; la fecha en el paso "Depreciación recuperable (RCV)".
// El estado lo calcula utils/recoverableDepreciation.js con los cheques.
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { getChecksForClaimRecord } from '../../services/claimService';
import { formatDateToMMDDYYYY } from '../../utils/dateHelpers';
import { RD_STATUS_LABELS, rdAmount, rdStatus } from '../../utils/recoverableDepreciation';

const money = value => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);

const RecoverableDepreciationCard = ({ claimRecord, language }) => {
  const es = language === 'es';
  const { isAdmin, userAdjusterName, userCanViewAllClaims, userRoleKey } = useAuth();
  const [checks, setChecks] = useState(null);
  const amount = rdAmount(claimRecord);

  useEffect(() => {
    if (amount === null) return undefined;
    let cancelled = false;
    getChecksForClaimRecord(claimRecord, isAdmin, { name: userAdjusterName, canViewAll: userCanViewAllClaims, summaryOnly: userRoleKey === 'csr_assistant' })
      .then(list => { if (!cancelled) setChecks(list); })
      .catch(error => { console.error('Error loading checks for RD:', error); if (!cancelled) setChecks([]); });
    return () => { cancelled = true; };
  }, [claimRecord.id, amount === null]); // eslint-disable-line react-hooks/exhaustive-deps

  if (amount === null) return null;
  const status = checks === null ? null : rdStatus(claimRecord, checks);

  return (
    <section className={`cd-detail-panel rd-card ${status === 'to_request' ? 'is-due' : ''}`} aria-labelledby="rd-card-title">
      <h2 id="rd-card-title">Recoverable Depreciation</h2>
      <div className="cd-claim-row"><span className="cd-label">{es ? 'Monto (del estimado)' : 'Amount (from estimate)'}</span><span className="cd-value">{money(amount)}</span></div>
      <div className="cd-claim-row">
        <span className="cd-label">{es ? 'Estado' : 'Status'}</span>
        <span className="cd-value" role="status">{status ? RD_STATUS_LABELS[status][es ? 0 : 1] : (es ? 'Cargando…' : 'Loading…')}</span>
      </div>
      {claimRecord.rdRequestedDate && (
        <div className="cd-claim-row"><span className="cd-label">{es ? 'Pedida al seguro' : 'Requested from insurance'}</span><span className="cd-value">{formatDateToMMDDYYYY(claimRecord.rdRequestedDate)}</span></div>
      )}
      {status === 'to_request' && (
        <p className="rd-card-hint">
          {es
            ? 'El cliente ya cobró: envía al seguro las pruebas de pago y reparación, pide la RD y anota la fecha en el paso "Depreciación recuperable (RCV)".'
            : 'The client has been paid: send the insurance the payment and repair proof, request the RD and record the date in the "Recoverable depreciation (RCV)" step.'}
        </p>
      )}
    </section>
  );
};

export default RecoverableDepreciationCard;
